// test1076
(1076 && 0);
